import React, { LegacyRef, useCallback, useEffect, useRef } from 'react';

import { Pressable, Text, View } from 'react-native';

import CheckmarkIcon from 'assets/images/svgs/ico_checkmark.svg';

import setAccessibilityFocusTo from 'services/accessibility/setAccessibilityFocusTo';

import { COLOR } from 'utils/colors';
import { isTablet, isWeb } from 'utils/responsiveness';

import { DateItem } from 'screens/Epg/hooks/useDatePicker';

import styles from './styles';

type Props = {
    item: DateItem;
    buttonWidth: number;
    handleClose: () => void;
    onPressDatePickerItem: (item: DateItem) => void;
    testID?: string;
    screenReaderEnabled?: boolean;
};

const DatePickerRowItem = ({
    item,
    buttonWidth,
    handleClose,
    onPressDatePickerItem,
    testID,
    screenReaderEnabled,
}: Props) => {
    const pressableRef = useRef(undefined);
    const onPressRowItem = useCallback(() => {
        onPressDatePickerItem(item);
        handleClose();
    }, [item, handleClose, onPressDatePickerItem]);

    useEffect(() => {
        if (item.isSelected && isTablet && screenReaderEnabled) {
            setTimeout(() => setAccessibilityFocusTo(pressableRef), 500);
        } else if (item.isSelected && isWeb) {
            setAccessibilityFocusTo(pressableRef);
        }
    }, [item.isSelected, screenReaderEnabled]);

    return (
        <Pressable
            style={[
                styles.container,
                {
                    width: buttonWidth,
                },
                item.isSelected && styles.selectedItem,
            ]}
            onPress={onPressRowItem}
            accessibilityLabel={item.label}
            aria-selected={item.isSelected}
            testID={testID}
            ref={pressableRef as unknown as LegacyRef<View>}
            role="row"
        >
            <Text
                style={[styles.title, item.isSelected && styles.selectedTitle]}
            >
                {item.label}
            </Text>
            {item.isSelected && (
                <CheckmarkIcon
                    fill={COLOR.background}
                    style={styles.checkMark}
                />
            )}
        </Pressable>
    );
};

export default DatePickerRowItem;
